
import Header from './Header.vue';
import {useI18n} from 'vue-i18n';
import {computed, defineComponent} from 'vue';
import {getPortalUrl} from '@/utils/portalUrl';

export default defineComponent(
    {
      name: 'StartSection',
      components: {Header},
      props: {
        msg: String,
      },
      setup() {
        const {t, locale} = useI18n();
        const registerUrl = computed(() => getPortalUrl('register', locale.value));
        return {t, locale, registerUrl};
      },
    }
);
